export const handleChangeModuleData = (
  e: { target: { name: any; value: any } },
  process: any
) => {
  const { name, value } = e.target;
  process[name] = value;
};
